import { RouteType } from "../../../types/RouteType";

const DeliveryTicketGenerationWorkflowRoute: RouteType = {
  name: "Delivery Ticket Generation",
  path: "/workflows/delivery-ticket-generation",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./DeliveryTicketGenerationWorkflowHeader"),
      title: "Generate Delivery Ticket",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./DeliveryTicketGenerationWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async () => {
    return true;
  },
};

export default DeliveryTicketGenerationWorkflowRoute;
